<script>
import { Radar, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'

export default {
  extends: Radar,
  props: ['height', 'options', 'chartData', 'channelData', 'userId'],
  mixins: [mixins.reactiveProp],

  mounted () {
    var self = this

    // console.log(this.chartData)
    // console.log(this.channelData)

    const chartColorScheme = [
      // '#20c997',  // teal
      // '#17a2b8',  // cyan
      // '#6f42c1',  // purple
      '#ffc107',  // brand warning (yellow)
      // '#c8ced3',  // gray 300
      '#63c2de',  // brand secondary (light blue)
      '#6610f2',  // indigo
      '#73818f',  // gray 600
    ]

    let channelArrayPosMap = {}
    let labels = []
    let chartDatasets = []

    // let chartDataset = {
    //   label: this.label,
    //   data: []
    // }
    let pos = 0

    // for(const channel of this.channelData) {
    //   labels.push('#' + channel.name)
    //   channelArrayPosMap[channel.id] = pos
    //   pos++
    // }

    let allChannelIds = []
    for(const row of this.chartData) {
      allChannelIds.push(row.channel_id)
    }
    let uniqueChannelIds = [...new Set(allChannelIds)]
    for(const channelId of uniqueChannelIds) {
      let c = self.channelData.find(channel => channel.id == channelId)
      labels.push('#' + c.name)
      channelArrayPosMap[channelId] = pos
      pos++
    }

    let mentionerDataset = {
      label: 'Mentioned Others',
      data: new Array(pos + 1).fill(0)
    }
    let mentionedDataset = {
      label: 'Was Mentioned',
      data: new Array(pos + 1).fill(0)
    }

    for(const row of this.chartData) {
      // console.log(row)
      let channelPos = channelArrayPosMap[row.channel_id]

      if(row.at_id == this.userId) {
        // insert into mentionedDataset
        let curVal = mentionedDataset.data[channelPos]
        // console.log('mentioned current val for channel ' + row.channel_id + ': ' + curVal)

        mentionedDataset.data.splice(channelPos, 1, curVal + row.mentions)


      } else if(row.sender_id == this.userId) {
        // insert into mentionerDataset
        let curVal = mentionerDataset.data[channelPos]
        // console.log('mentioner current val for channel ' + row.channel_id + ': ' + curVal)

        mentionerDataset.data.splice(channelPos, 1, curVal + row.mentions)

      } else {
        console.log('Another user data somehow got in here, skipping')
        continue
      }
    }

    
    // for(const channel of this.chartData) {
    //   chartDataset.data.push(channel[self.dataKey])

    //   let c = this.channelData.find(chan => chan.id == channel.channel_id)
    //   labels.push('#' + c.name)
    // }

    this.renderChart({
      labels: labels,
      datasets: [mentionerDataset, mentionedDataset]
    }, 
    // chart options
    {
      spanGaps: true,
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'right'
      },

      plugins: {
        colorschemes: {
          scheme: chartColorScheme,
          // reverse: true
        }
      }

    })
        
  }
}
</script>
